import { ReservationPreChekin } from '@/core/domain/reservation/models/reservation-response';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

@Component({
    selector: 'fe-reservation-info',
    templateUrl: './reservation-info.component.html',
    styleUrls: ['./reservation-info.component.scss'],
})
export class ReservationInfoComponent {
    @Input() reservation!: ReservationPreChekin;
    @Input() selected: boolean | false | undefined;
    @Output() selectReservation = new EventEmitter<void>();

    constructor(
        @Inject('DATE_FORMAT_PROGRESS_BAR')
        public dateFormatProgressBar: string,
    ) {}

    SelectReservation() {
        this.selectReservation.emit();
    }
}
